<template>
    <div class="downloadApk">
        <div class="logo">
            <img :src="teammodelLogo" />
            <span class="logo-title">HiTA5</span>
        </div>
        <div style="padding: 5px;">
            {{ $t('downloadAPK_1') }}:
        </div>
        <span class="cont scrollstyle">
            {{ description }}
        </span>
        <div class="footer">
            <div style="margin-bottom: 3px;">{{ $t('downloadAPK_3') }}</div>
            <n-button style="width: 100%;" type="info" strong size="large"  @click="downloadHiTA5()">
                <template #icon>
                    <n-icon :component="DownloadOutline" />
                </template>
                {{ $t('downloadAPK_2') }}
            </n-button>
        </div>
    </div>
</template>
<script>
// import {reactive, ref, computed, watch, watchEffect} from 'vue'
import { ref, onBeforeMount} from 'vue'
import { useRoute } from 'vue-router';
import { useStore } from "vuex"
import { jsFn } from '@/utils/jsFn'
import { useI18n } from "vue-i18n";
import { DownloadOutline } from '@vicons/ionicons5'

export default {
    setup() {
        const route = useRoute()
        const store = useStore()
        const i18n = useI18n();

        var serverLocation = jsFn.isCN() ? 'china' : 'global'
        var simpLang = route.params.lang
        var lang = ''
        var verInfo = {}
        const description = ref('')

        // 設定頁面的語系
        i18n.locale.value = simpLang;
        localStorage.setItem("lang", simpLang);
        switch (simpLang) {
            case 'tw':
                lang = 'zh-tw'
            break;
            case 'cn':
                lang = 'zh-cn'
            break;
            // case 'jp':
            //     lang = 'ja-jp'
            // break;
            default:
                lang = 'en-us'
            break;
        }
        
        // 圖檔設定
        var teammodelLogo = require("@/assets/img/TEAMModellogo_" + (simpLang == 'jp' ? 'en' : simpLang)  + ".png");

        onBeforeMount(async() => {
            try {
                await store.dispatch('GetAPPVerInfo').then( res =>{
                    verInfo = res
                    description.value = res.description[lang]
                    window.location.href = res.APK[serverLocation]
                })
            } catch (error) {
                console.log(error)
            }
        });

        function downloadHiTA5() {
            window.location.href = verInfo.APK[serverLocation]
        }

        return {
            description,
            lang,
            serverLocation,
            teammodelLogo,
            downloadHiTA5,
            DownloadOutline
        }
    },
}
</script>